import { i18n } from 'next-i18next'

export const playlistTitleRules = (checkIsDuplicated: (title: string) => boolean) => {
  return {
    required: {
      value: true,
      message: i18n?.t('Playlist__enter__name') ?? '',
    },
    validate: (title: string) =>
      (!checkIsDuplicated(title) || i18n?.t('Playlist__already_in_use')) ?? '',
  }
}
